import {
  GET_ANNOUNCEMENTS_LOADING,
  GET_ANNOUNCEMENTS_SUCCESS,
  GET_ANNOUNCEMENTS_ERROR,
  CREATE_ANNOUNCEMENTS_LOADING,
  CREATE_ANNOUNCEMENTS_SUCCESS,
  CREATE_ANNOUNCEMENTS_ERROR,
  EDIT_ANNOUNCEMENTS_LOADING,
  EDIT_ANNOUNCEMENTS_SUCCESS,
  EDIT_ANNOUNCEMENTS_ERROR,
  DELETE_ANNOUNCEMENTS_LOADING,
  DELETE_ANNOUNCEMENTS_SUCCESS,
  DELETE_ANNOUNCEMENTS_ERROR,
} from "../../../constant/actionTypes";
import { apiDelete, apiGet, apiPut } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";

export const getAnnouncement = () => (dispatch) => {
  dispatch({ type: GET_ANNOUNCEMENTS_LOADING });
  apiGet(
    ApiEndpoints.announcement.base,
    (response) => {
      // console.log("get announcement response ==============> ", response);
      if (response.error == true) {
        dispatch({ type: GET_ANNOUNCEMENTS_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_ANNOUNCEMENTS_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_ANNOUNCEMENTS_ERROR, response: error });
    }
  );
};

export const createAnnouncement = (data) => (dispatch) => {
  dispatch({ type: CREATE_ANNOUNCEMENTS_LOADING });
  apiPut(
    `${ApiEndpoints.announcement.base}${ApiEndpoints.announcement.add}`,
    data,
    (response) => {
    //  console.log("create announcement response ....", response);

      if (response.error == true) {
        dispatch({
          type: CREATE_ANNOUNCEMENTS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: CREATE_ANNOUNCEMENTS_SUCCESS, response: response });
      }
    },
    (error) => {
    //  console.log("error ===>>>>", error);
      dispatch({ type: CREATE_ANNOUNCEMENTS_ERROR, response: error });
    }
  );
};

export const deleteAnnouncement = (id) => (dispatch) => {
  dispatch({ type: DELETE_ANNOUNCEMENTS_LOADING });
  apiDelete(
    `${ApiEndpoints.announcement.base}${ApiEndpoints.announcement.delete}${id}`,
    (response) => {
    //  console.log("delete announcement response ....", response);

      if (response.error == true) {
        dispatch({
          type: DELETE_ANNOUNCEMENTS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: DELETE_ANNOUNCEMENTS_SUCCESS, response: response });
      
      }
    },
    (error) => {
     // console.log("error ===>>>>", error);
      dispatch({ type: DELETE_ANNOUNCEMENTS_ERROR, response: error });
    }
  );
};

export const editAnnouncement = (id, data) => (dispatch) => {
  dispatch({ type: EDIT_ANNOUNCEMENTS_LOADING });
  apiPut(
    `${ApiEndpoints.announcement.base}${ApiEndpoints.announcement.update}${id}`,
    data,
    (response) => {
     // console.log("edit announcement response ....", response);

      if (response.error == true) {
        dispatch({
          type: EDIT_ANNOUNCEMENTS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: EDIT_ANNOUNCEMENTS_SUCCESS, response: response });
      }
    },
    (error) => {
     // console.log("error ===>>>>", error);
      dispatch({ type: EDIT_ANNOUNCEMENTS_ERROR, response: error });
    }
  );
};
